import React, { useEffect, useState } from "react";
import HomeSidebar from "./../homeSidebar/homeSidebar";
import SettingIcon from "../../../imgs/settingIcon.svg";
import AccountCard from "./AccountCard";
import Funds from './Funds';
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Payment from "./Payments";
import { gql, useLazyQuery } from "@apollo/client";
import { SEARCH_PROFILE } from "../../../graphql/query/profiles";

const Account = () => {

  const email = localStorage.getItem('email');
  const [balance, setBalance] = useState(0);

  

  const [getProfileByEmail] = useLazyQuery(gql(SEARCH_PROFILE), {
    fetchPolicy: "cache-and-network",
    onCompleted: ({searchProfileByEmail}) => setBalance(searchProfileByEmail[0].balance)
  })
  useEffect(() => {
    getProfileByEmail({
      variables: {
        email
      }
    })
  }, [email])

  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <div className="home-content bounty-contents">
        <div className="bounty-top justify-content-between">
          <div className="row m-0 justify-content-between">
            <img src={SettingIcon} alt="logo" />
            <h2 className="heading ml-3">Account</h2>
          </div>
          <div>
            <h1 className="heading mt-2" >${balance}</h1>
            <p> Account balance</p>
          </div>
        </div>
        <div className="bounty-tabes">
          <Tabs defaultActiveKey="General" transition={false}>
            <Tab eventKey="General" title="General">
              <div className="accounts-tab-content">
                <AccountCard />
              </div>
            </Tab>
            {/* <Tab eventKey="Payments" title="Payment">
              <div className="accounts-tab-content">
                <Payment />
              </div>
            </Tab> */}
            <Tab eventKey="myintros" title="Funds">
              <div className="accounts-tab-content">
                <Funds />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
      {/* <BountyCardInfo /> */}
    </div>
  );
};

export default Account;
